import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SearchNav from '../SearchNav';
import { actions } from '../../../Data/ReduxViewModels/SearchWorksheets';
import { worksheetNavLinks } from '../../../Data/Search';
import deepEquals from 'Lib/Object/deepEquals';

const recentWorksheetsLimit = 10;

const RecentTests = () => {
  const recentWorksheetLinks = useSelector(
    (state) => worksheetNavLinks(state.searchWorksheets.recentWorksheets, null),
    deepEquals
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.recentGet({ limit: recentWorksheetsLimit }));
  }, [dispatch]);

  return (
    <SearchNav
      links={recentWorksheetLinks}
      heading={'Your Recent Tests'}
      placeholder={'Tests that you have recently worked on will appear here.'}
    />
  );
};

export { RecentTests };
export default RecentTests;
